enum PolicyEnable {
  YES = 'YES',
  NO = 'NO',
}

export default PolicyEnable;
